(function () {
  'use strict';

  var STORAGE_COMPLETED = 'nurey_quiz_completed';
  var STORAGE_DISMISSED_AT = 'nurey_quiz_dismissed_at';
  var STORAGE_SHOWN_SESSION = 'nurey_quiz_shown_session';
  var DISMISS_SUPPRESS_MS = 7 * 24 * 60 * 60 * 1000; // 7 days

  function safeGet(storage, key) {
    try {
      return storage.getItem(key);
    } catch (e) {
      return null;
    }
  }

  function safeSet(storage, key, value) {
    try {
      storage.setItem(key, value);
    } catch (e) {
      /* ignore (private browsing / storage disabled) */
    }
  }

  function shouldSuppress() {
    if (safeGet(window.localStorage, STORAGE_COMPLETED) === '1') return true;
    if (safeGet(window.sessionStorage, STORAGE_SHOWN_SESSION) === '1') return true;
    var dismissedAt = safeGet(window.localStorage, STORAGE_DISMISSED_AT);
    if (dismissedAt && Date.now() - parseInt(dismissedAt, 10) < DISMISS_SUPPRESS_MS) return true;
    return false;
  }

  var TOTAL_STEPS = 5;

  function initQuizPopup() {
    var root = document.querySelector('[data-quiz-popup]');
    if (!root) return;

    var panel = document.getElementById('QuizPopupPanel');
    var body = root.querySelector('[data-quiz-body]');
    var progressFill = root.querySelector('[data-quiz-progress-fill]');
    var stepLabelEl = root.querySelector('[data-quiz-step-label]');
    var stepLabelTemplate = stepLabelEl ? stepLabelEl.getAttribute('data-template') : 'Step {current}/5';

    var state = {
      concerns: [],
      tone: null,
      currentStep: '1'
    };

    var lastFocused = null;

    function stepEl(step) {
      return root.querySelector('[data-quiz-step="' + step + '"]');
    }

    function updateProgress(step) {
      if (!stepLabelEl) return;
      var numeric = parseInt(step, 10);
      if (isNaN(numeric)) {
        root.classList.add('is-success');
        return;
      }
      root.classList.remove('is-success');
      var pct = (numeric / TOTAL_STEPS) * 100;
      if (progressFill) progressFill.style.width = pct + '%';
      stepLabelEl.textContent = stepLabelTemplate.replace('{current}', numeric);
    }

    function goToStep(step) {
      var current = stepEl(state.currentStep);
      var next = stepEl(step);
      if (!next) return;
      if (current) current.hidden = true;
      next.hidden = false;
      state.currentStep = step;
      updateProgress(step);
      if (body) body.scrollTop = 0;
      var firstFocusable = next.querySelector('button, input, a[href]');
      if (firstFocusable) firstFocusable.focus({ preventScroll: true });
    }

    function recommendationKey() {
      var wantsCorrect = state.concerns.indexOf('darkspots') !== -1 || state.concerns.indexOf('uneventone') !== -1;
      var wantsHydrate = state.concerns.indexOf('dryness') !== -1;
      var wantsProtect = state.concerns.indexOf('sunprotection') !== -1;
      var parts = ['clean'];
      if (wantsCorrect) parts.push('correct');
      if (wantsHydrate) parts.push('hydrate');
      if (wantsProtect) parts.push('protect');
      return parts.join('-');
    }

    function showRecommendation() {
      var key = recommendationKey();
      var results = root.querySelectorAll('[data-quiz-result]');
      results.forEach(function (el) {
        el.hidden = el.getAttribute('data-quiz-result') !== key;
      });
    }

    // ---- concern (multi-select) ----
    var concernButtons = root.querySelectorAll('[data-quiz-concern]');
    var step1Cta = root.querySelector('[data-quiz-next="2"]');
    concernButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = btn.getAttribute('data-quiz-concern');
        var idx = state.concerns.indexOf(value);
        if (idx === -1) {
          state.concerns.push(value);
          btn.classList.add('is-selected');
        } else {
          state.concerns.splice(idx, 1);
          btn.classList.remove('is-selected');
        }
        if (step1Cta) step1Cta.disabled = state.concerns.length === 0;
      });
    });

    // ---- tone (single-select) ----
    var toneButtons = root.querySelectorAll('[data-quiz-tone]');
    var step2Cta = root.querySelector('[data-quiz-next="3"]');
    toneButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        toneButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        state.tone = btn.getAttribute('data-quiz-tone');
        if (step2Cta) step2Cta.disabled = false;
      });
    });

    // ---- next / back navigation ----
    root.querySelectorAll('[data-quiz-next]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var target = btn.getAttribute('data-quiz-next');
        if (target === '3') showRecommendation();
        goToStep(target);
      });
    });
    root.querySelectorAll('[data-quiz-back]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        goToStep(btn.getAttribute('data-quiz-back'));
      });
    });

    // ---- email form ----
    // Real native submission (full page round-trip), NOT intercepted with
    // fetch/preventDefault: Shopify's customer/contact form requires its own
    // CAPTCHA token, which its platform script attaches to the form's real
    // submit lifecycle. An AJAX-intercepted submit races ahead of that token
    // and is rejected server-side ("Missing CAPTCHA token") — verified live.
    // Success/error is instead detected server-side on the next page load
    // via form.posted_successfully? / form.errors (see [data-quiz-form-state]
    // below), which survives the redirect-back that Shopify performs.
    var form = root.querySelector('#QuizPopupForm');
    if (form) {
      var tagsField = form.querySelector('[data-quiz-tags-field]');
      var consentCheckbox = form.querySelector('[data-quiz-consent-checkbox]');

      form.addEventListener('submit', function () {
        var tags = ['nurey_quiz_popup'];
        state.concerns.forEach(function (c) { tags.push('quiz-concern-' + c); });
        if (state.tone) tags.push('quiz-tone-' + state.tone);
        tags.push('quiz-rec-' + recommendationKey());
        if (consentCheckbox && consentCheckbox.checked) tags.push('newsletter');
        if (tagsField) tagsField.value = tags.join(', ');
      });
    }

    // ---- open / close ----
    var closeTimer = null;
    var FADE_MS = 400;

    function prefersReducedMotion() {
      return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    }

    function open() {
      if (closeTimer) {
        window.clearTimeout(closeTimer);
        closeTimer = null;
      }
      lastFocused = document.activeElement;
      root.classList.add('is-open');
      root.setAttribute('aria-hidden', 'false');
      document.documentElement.classList.add('quiz-popup-lock');
      // Force a reflow so the hidden start state is committed before
      // is-visible is added; otherwise the transition would not run.
      void root.offsetWidth;
      root.classList.add('is-visible');
      if (panel) panel.focus({ preventScroll: true });
      document.addEventListener('keydown', onKeydown);
      safeSet(window.sessionStorage, STORAGE_SHOWN_SESSION, '1');
    }

    function close() {
      root.classList.remove('is-visible');
      root.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
      function finishClose() {
        root.classList.remove('is-open');
        document.documentElement.classList.remove('quiz-popup-lock');
        closeTimer = null;
      }
      if (prefersReducedMotion()) {
        finishClose();
      } else {
        closeTimer = window.setTimeout(finishClose, FADE_MS);
      }
      if (state.currentStep !== 'success') {
        safeSet(window.localStorage, STORAGE_DISMISSED_AT, String(Date.now()));
      }
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        close();
        return;
      }
      if (event.key !== 'Tab' || !panel) return;
      var focusable = panel.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), [tabindex]:not([tabindex="-1"])');
      if (!focusable.length) return;
      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    root.querySelectorAll('[data-quiz-close]').forEach(function (el) {
      el.addEventListener('click', close);
    });

    // ---- resume after the native form round-trip ----
    var resumed = false;
    var formState = root.querySelector('[data-quiz-form-state]');
    if (formState) {
      var success = formState.getAttribute('data-success') === 'true';
      var hasErrors = formState.getAttribute('data-has-errors') === 'true';
      if (success) {
        safeSet(window.localStorage, STORAGE_COMPLETED, '1');
        goToStep('success');
        open();
        resumed = true;
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', window.location.pathname + window.location.search);
        }
      } else if (hasErrors) {
        goToStep('5');
        open();
        resumed = true;
      }
    }

    if (!resumed && !shouldSuppress()) {
      var delaySeconds = parseInt(root.getAttribute('data-delay-seconds'), 10) || 12;
      var html = document.documentElement;
      // Don't open on top of another blocking UI (mobile menu, cart drawer,
      // product zoom, intro overlay); re-check shortly instead of skipping.
      var isOtherUiOpen = function () {
        return !!(
          document.querySelector('.site-header.is-open, .cart-drawer.is-open, .product-zoom-modal.is-open') ||
          html.classList.contains('cart-drawer-lock') ||
          html.classList.contains('intro-lock')
        );
      };
      var tryOpen = function () {
        if (shouldSuppress()) return;
        if (isOtherUiOpen()) {
          window.setTimeout(tryOpen, 2000);
          return;
        }
        open();
      };
      window.setTimeout(tryOpen, delaySeconds * 1000);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuizPopup);
  } else {
    initQuizPopup();
  }
})();
